module.exports = __webpack_public_path__ + "img/choko_dadler.7d618099.jpg";